import { CommandPayload } from "src/data/commands";
import i18next from "src/i18n/config";

import { MdmCommand, MdmCommandStatus } from "@dashboard/devices/types/commands";

export const getCommandName = (payload: CommandPayload): string => {
    if (!payload) {
        return "Unknown command";
    } else {
        return payload.caption || payload.command;
    }
};

export const getCommandStatusLabel = (statusKey: MdmCommandStatus): string => {
    switch (statusKey) {
        case "unknown":
            return i18next.t("common:status.unknown");
        case "pending":
            return i18next.t("common:status.pending");
        case "running":
            return i18next.t("sidepanels:devicePanel.commandsTab.status.running");
        case "successful":
            return i18next.t("sidepanels:devicePanel.commandsTab.status.successful");
        case "failed":
            return i18next.t("sidepanels:devicePanel.commandsTab.status.failed");
        case "received":
            return i18next.t("sidepanels:devicePanel.commandsTab.status.received");
        case "ignored":
            return i18next.t("sidepanels:devicePanel.commandsTab.status.ignored");
        case "queued":
            return i18next.t("sidepanels:devicePanel.commandsTab.status.queued");
        default:
            return statusKey;
    }
};

export const hasUnfinishedCommands = (commands: MdmCommand[]): boolean => {
    const finishedStatuses: MdmCommandStatus[] = ["successful", "ignored"];
    return commands.some((command) => !finishedStatuses.includes(command.status));
};
